import React from 'react';
import PropTypes from 'prop-types';

import PhoneNumberInput from '../PhoneNumberInput';
import FormikField from './FormikField';

const FormikPhoneNumberField = ({ field, form, showNoError, ...other }) => (
  <FormikField field={field} form={form} showNoError={showNoError}>
    <PhoneNumberInput
      onChange={({ target }) => {
        form.setFieldValue(field.name, target.value, true);
        form.setTouched({ [field.name]: true });
      }}
      {...other}
    />
  </FormikField>
);

FormikPhoneNumberField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldError: PropTypes.func,
    setFieldValue: PropTypes.func,
    setTouched: PropTypes.func,
  }).isRequired,
  showNoError: PropTypes.bool,
  other: PropTypes.object,
};

FormikPhoneNumberField.defaultProps = {
  showNoError: false,
  other: null,
};

export default FormikPhoneNumberField;
